// @ts-nocheck
export default (sizeVariant?: string) => {
    switch (sizeVariant) {
        case "default":
            return "large";
        case "small":
            return "medium";
        case "xsmall":
            return "small";
        default:
            return undefined;
    }
};
